// test33
(33 && 0);
